import React from "react";
import { Controller, useForm } from "react-hook-form";
import EditorSearchIcon from "@atlaskit/icon/glyph/editor/search";

import { Grid } from "../../UI/Grid";
import { Button } from "../../UI/Button";
import useAuth from "../../routes/login/AuthContext";
import { getControllerTextFieldRender } from "../../helpers/getControllerTextFieldRender";
import { useSnackbar } from "../../hooks/useSnackbar";
import { Typography } from "../../UI/Typography";
import { LoadUserInfo } from "../../services/UserApi";

interface IProps {
  showTitle?: boolean;
  onSuccess: (data: any) => void;
}

interface IFormData {
  userId: string;
}

export const UserSearchByUserIdForm: React.FC<IProps> = (props) => {
  const { getAuthToken } = useAuth();
  const { showErrorSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = React.useState(false);
  const { control, handleSubmit, reset } = useForm<IFormData>({
    defaultValues: {
      userId: "",
    },
  });

  const onSubmit = async (data: IFormData) => {
    setIsLoading(true);

    try {
      const res = await LoadUserInfo(data.userId.trim(), await getAuthToken());

      const user = res.result;

      if (user) {
        const modifiedValues = [{ ...user, id: user.membershipId, name: user.firstName + " " + user.lastName }];

        props.onSuccess(modifiedValues);
      }
    } catch (error: any) {
      showErrorSnackbar(error.message);
    }

    reset();

    setIsLoading(false);
  };

  return (
    <Grid container spacing={2} alignItems="end" component="form" onSubmit={handleSubmit(onSubmit)}>
      {props.showTitle && (
        <Grid item xs={12}>
          <Typography gutterBottom variant="h6">
            Search By RoomSync Id
          </Typography>
        </Grid>
      )}
      <Grid item>
        <Controller
          name="userId"
          control={control}
          render={getControllerTextFieldRender({ label: "RoomSync Membership ID" })}
        />
      </Grid>
      <Grid item mb={0.5}>
        <Button
          type="submit"
          appearance="primary"
          isLoading={isLoading}
          iconBefore={<EditorSearchIcon label="Search" />}
        >
          Search
        </Button>
      </Grid>
    </Grid>
  );
};

UserSearchByUserIdForm.defaultProps = {
  showTitle: false,
};
